/**
 * Geocode an address string to get coordinates
 * Uses the Google Maps Geocoding API
 */
import { getGoogleMapsApiKey } from '../services/GoogleMapsService';

export interface GeocodeResult {
  latitude: number;
  longitude: number;
  formattedAddress: string;
}

export async function geocodeAddress(address: string): Promise<GeocodeResult | null> {
  // Get API key safely (must await since it's async)
  const apiKey = await getGoogleMapsApiKey();

  if (!apiKey) {
    console.warn('⚠️ Geocoding skipped: GOOGLE_MAPS_API_KEY not found');
    return null;
  }

  try {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    const response = await fetch(url);
    const data = await response.json();

    // An address without a match uses the scheduler's normal travel fallback.
    if (response.ok && data.status === 'ZERO_RESULTS') return null;

    if (data.status === 'OK' && data.results && data.results.length > 0) {
      const result = data.results[0];
      const { lat, lng } = result.geometry.location;
      
      return {
        latitude: lat,
        longitude: lng,
        formattedAddress: result.formatted_address
      };
    } else {
      console.warn('⚠️ Geocoding failed:', data.status, data.error_message);
      return null;
    }
  } catch (error) {
    console.error('❌ Error calling Geocoding API:', error);
    return null;
  }
}
